(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('PracticeController', PracticeController);

    PracticeController.$inject = ['$scope', '$state', 'DataUtils', 'Practice', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PracticeController ($scope, $state, DataUtils, Practice, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = 1000;//paginationConstants.itemsPerPage;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        
        if (pagingParams.teaser == "true") {
        	vm.teaser = true;
        } else {
        	vm.teaser = false;
        }

        loadAll();

        function loadAll () {
            Practice.query({
                page: pagingParams.page - 1,
                teaser: vm.teaser,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.practices = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                teaser: vm.teaser,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();
